import { render, staticRenderFns } from "./TabServicosTerceiros.vue?vue&type=template&id=77e0a4f4&scoped=true&"
import script from "./TabServicosTerceiros.vue?vue&type=script&lang=js&"
export * from "./TabServicosTerceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0a4f4",
  null
  
)

export default component.exports